import React from "react";
import footerImg from "../../assets/images/skinefit/imgs/Artboard 17.jpg";
const Footer = () => {
  return (
    <div className="bg-[#EDF2E6]">
      <div className="mx-10">
        <div className="grid grid-cols-1 md:grid-cols-2 items-center py-10 gap-5">
          <div className="mx-auto">
            <img
              src={footerImg}
              alt=""
              className="h-[300px] w-[300px] object-cover rounded"
            />
          </div>
          <div className="">
            <h1 className="text-2xl font-extralight leading-8 tracking-widest">
              Our Mission
            </h1>
            <p className="text-xs tracking-widest leading-8 my-5">
              Our mission is the reason we exist today and many years to come.We
              truly believe beauty creates confidence to build a better world.It
              is our unwavering promise to provide always-the-best skincare
              solution for reasonable prices.
            </p>
            <a href="https://skinefits.pitiplus.app/">
              <button className="bg-[#4E5F3B] font-extralight leading-8 tracking-widest text-white text-sm px-10 py-2 rounded-sm shadow-sm hover:scale-105 transition">
                Shop Now
              </button>
            </a>
          </div>
        </div>
      </div>
      <p className="text-center pb-10 text-sm tracking-widest leading-8 font-light mx-5">
        Copyright © {new Date().getFullYear()} - All right reserved by Skinefits
      </p>
    </div>
  );
};

export default Footer;
